/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceGeneratePDFBuffer200Response
 */
export interface InvoiceGeneratePDFBuffer200Response {
    /**
     * 
     * @type {object}
     * @memberof InvoiceGeneratePDFBuffer200Response
     */
    buffer?: object;
}

/**
 * Check if a given object implements the InvoiceGeneratePDFBuffer200Response interface.
 */
export function instanceOfInvoiceGeneratePDFBuffer200Response(value: object): value is InvoiceGeneratePDFBuffer200Response {
    return true;
}

export function InvoiceGeneratePDFBuffer200ResponseFromJSON(json: any): InvoiceGeneratePDFBuffer200Response {
    return InvoiceGeneratePDFBuffer200ResponseFromJSONTyped(json, false);
}

export function InvoiceGeneratePDFBuffer200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceGeneratePDFBuffer200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'buffer': json['buffer'] == null ? undefined : json['buffer'],
    };
}

export function InvoiceGeneratePDFBuffer200ResponseToJSON(json: any): InvoiceGeneratePDFBuffer200Response {
    return InvoiceGeneratePDFBuffer200ResponseToJSONTyped(json, false);
}

export function InvoiceGeneratePDFBuffer200ResponseToJSONTyped(value?: InvoiceGeneratePDFBuffer200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'buffer': value['buffer'],
    };
}

